import { render } from "./LargeTextareaModal.vue?vue&type=template&id=5907e790"
import script from "./LargeTextareaModal.vue?vue&type=script&lang=js"
export * from "./LargeTextareaModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__